<template>
  <nav aria-label="ページナビゲーション">
    <ul class="pagination" v-if="pager[pager_key]">
      <li class="page-item" :class="{ disabled: !pager[pager_key].prev }">
        <span class="page-link" @click="handleClick('prev')">{{
          prevLabel
        }}</span>
      </li>
      <li class="page-item" v-for="item in visiblePages" :key="item.pageNum">
        <span
          :class="page_link_class(item)"
          @click="handleClick(item.pageNum)"
          >{{ item.label }}</span
        >
      </li>
      <li class="page-item" :class="{ disabled: !pager[pager_key].next }">
        <span class="page-link" @click="handleClick('next')">{{
          nextLabel
        }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BsPageNav',
  props: {
    pager_key: {
      type: String,
      required: true
    },
    prevLabel: {
      type: String,
      default: '前'
    },
    nextLabel: {
      type: String,
      default: '次'
    },
    maxVisiblePages: {
      type: Number,
      default: 5
    }
  },
  computed: {
    ...mapState({
      pager: state => state.apidata.pager
    }),
    currentPage() {
      return this.pager[this.pager_key].current_page
    },
    totalPages() {
      return this.pager[this.pager_key].center.length
    },
    visiblePages() {
      const center = this.pager[this.pager_key].center
      if (Array.isArray(center) && center?.length <= this.maxVisiblePages) {
        return center
      }

      const currentIndex = center.findIndex(item => item.behavior === 'active')
      const halfVisible = Math.floor(this.maxVisiblePages / 2)

      let start = Math.max(0, currentIndex - halfVisible)
      let end = start + this.maxVisiblePages

      if (end > this.totalPages) {
        end = this.totalPages
        start = Math.max(0, end - this.maxVisiblePages)
      }

      return center.slice(start, end)
    },
    page_link_class() {
      return item => {
        return item.behavior === 'active' ? 'page-link active' : 'page-link'
      }
    }
  },
  methods: {
    handleClick(pageNum) {
      if (pageNum === 'prev' && this.pager[this.pager_key].prev) {
        this.$emit('to_click_event', this.pager[this.pager_key].prev.page)
      } else if (pageNum === 'next' && this.pager[this.pager_key].next) {
        this.$emit('to_click_event', this.pager[this.pager_key].next.page)
      } else if (typeof pageNum === 'number') {
        this.$emit('to_click_event', pageNum)
      }
    }
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  list-style-type: none;
  padding: 0;
}
.page-item {
  margin: 0 2px;
  transition: all 1s ease;
}
.page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 2.5em; /* 数字の桁数に関わらず一定の幅を確保 */
  height: 2.5em; /* 高さも固定 */
  padding: 0 0.5em;
  border: 1px solid #007bff;
  color: #007bff;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background-color 1s, color 1s;
}
.page-link.active {
  background-color: #007bff;
  color: white;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
  opacity: 0.5;
}
</style>
